import {api} from '@/api/factory';

class Seasons {
    constructor() {}

    getFromSerial(serial_id) {
        return api({
            method: 'GET',
            url: `/v1/content-manager/series/${serial_id}/seasons`
        })

    }

    saveOrder(serial_id, season_id) {
        return api({
            url: `/v1/content-manager/series/${serial_id}/seasons/${season_id}/episodes/order`,
            method: "POST"
        })
    }

    create(serial_id, data) {
        return api({
            url: `/v1/content-manager/series/${serial_id}/seasons`,
            method: 'POST', 
            data: data
        })
    }

    edit(serial_id, data, season_id) {
        return api({
            url: `/v1/content-manager/series/${serial_id}/seasons/${season_id}`,
            method: 'PUT', 
            data: data
        })
    }
}

export default Seasons